import { removeBackground } from "@imgly/background-removal";
const dataUrlToBlob = (dataUrl) => {
  const matches = dataUrl.match(/^data:(.+);base64,(.*)$/);
  if (!matches) {
    return null;
  }
  const mime = matches[1];
  const binary = atob(matches[2]);
  const len = binary.length;
  const buffer = new Uint8Array(len);
  for (let i = 0; i < len; i += 1) {
    buffer[i] = binary.charCodeAt(i);
  }
  return new Blob([buffer], { type: mime });
};

export const createBlobFromImageSource = async (imageSource) => {
  if (!imageSource) {
    return null;
  }

  if (imageSource instanceof Blob) {
    return imageSource;
  }

  if (imageSource instanceof File) {
    return imageSource;
  }

  if (typeof imageSource === "string") {
    if (imageSource.startsWith("data:")) {
      return dataUrlToBlob(imageSource);
    }
    try {
      const response = await fetch(imageSource);
      return await response.blob();
    } catch (error) {
      console.error("Failed to convert image source to blob", error);
      return null;
    }
  }

  return null;
};

const blobToDataUrl = (blob) =>
  new Promise((resolve, reject) => {
    if (!blob) {
      resolve(null);
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(blob);
  });

export const removeImageBackground = async (imageSource) => {
  try {
    const blob = await createBlobFromImageSource(imageSource);
    if (!blob) {
      return null;
    }
    const dataUrl = await blobToDataUrl(blob);
    if (!dataUrl) {
      return null;
    }
    const result = await removeBackground(dataUrl);
    return result;
  } catch (error) {
    console.log(error);
    return null;
  }
};
